import React from 'react';
export const ContentBlockImageBreaker = ({ primaryImage, secondaryImage, }) => {
    return (React.createElement("section", { className: "my-3.5 md:my-8 mx-auto px-5 lg:px-[90px] max-w-[640px] lg:max-w-[1280px]" },
        React.createElement("div", { className: "flex flex-row gap-4 items-end" },
            React.createElement("div", null, primaryImage),
            React.createElement("div", null, secondaryImage))));
};
